import { Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { API_WHITEBOARD_APP_LOCATION } from '../../api/whiteboard/map/location';
import { LocationData } from '../../api/whiteboard/map/location/types';
import Loader from '../../components/common/loader';
import MapWhiteboard from '../../components/map-whiteboard/MapWhiteboard';

const isLocationData = (data: unknown): data is LocationData => {
  if (typeof data !== 'object' || data === null) {
    return false;
  }

  const typedData = data as { location?: { id?: string } };
  return Boolean(typedData.location && typeof typedData.location.id === 'string');
};

const MapWhiteboardPage = () => {
  const { error: locationError, data: locationData, isLoading } = useQuery(
    ['clientLocation'],
    API_WHITEBOARD_APP_LOCATION.getSingleLocation,
    { retry: false }
  );

  if (locationError) return <Typography>Error fetching location information</Typography>;
  if (isLoading) return <Loader />;
  if (isLocationData(locationData)) return <MapWhiteboard locationData={locationData} />;

  return <Typography>Unable to load location information for the map whiteboard.</Typography>;
};

export default MapWhiteboardPage;
